import React, { createContext, useContext, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

const SnackbarContext = createContext();

export function SnackbarProvider({ children }) {
  const [state, setState] = useState({ open: false, message: '', severity: 'success' });

  const showAlert = (message, severity = 'success') => setState({ open: true, message, severity });
  const showSnackbar = showAlert;
  const handleClose = () => setState(s => ({ ...s, open: false }));

  return (
    <SnackbarContext.Provider value={{ showAlert, showSnackbar }}>
      {children}
      <Snackbar open={state.open} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert onClose={handleClose} severity={state.severity} sx={{ width: '100%' }}>{state.message}</Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
}

export const useSnackbar = () => useContext(SnackbarContext);
export const useSnackbarContext = useSnackbar;
